import AppSettings from '../../../AppSettings';
// Librairies
import i18n from '../../../locales/i18n';
// Utils
import { categoryConfig } from './ElementHandlers';
import { resolveElementRefs } from './ElementRefs';

const BACKEND_ENDPOINT = AppSettings.getBackendUrl();

export const historyHandlers = {
    // Date choisie par l'utilisateur dans l'URL : l'API la garde, la date de saisie (X-Captured-At) ne la remplace pas
    'history.add': {
        describe: () => i18n.t("Ajout d'un état passé à l'historique"),
        buildRequest: async (op, context) => ({
            request: { method: 'post', url: `${BACKEND_ENDPOINT}${categoryConfig(op).path}/history/?date=${op.payload.date}`, data: await resolveElementRefs(op.payload.feature, context) }
        }),
        onSuccess: async (op, response) => ({ history: response.data })
    }
};
